export const notFound = {
  heading: 'このページは作成されていません',
  description: 'このページについて詳しく教えてください。作成いたします。',
};
